import { Input, Label, Select, Button } from '@favordelivery/tupperware'
import { css, styled } from 'styled-components'
import { mediaDesktop } from './breakPoints'

export const LabelSC = styled(Label)`
  ${p =>
    p.$hidden
      ? css`
          position: absolute;
          left: -10000px;
          top: auto;
          width: 1px;
          height: 1px;
          overflow: hidden;
        `
      : css`
          font-weight: ${p.theme.font.weight.normal};
          font-size: ${p.theme.font.size.title};
          margin: 24px 0 16px;
        `}
`

export const Err = styled.div`
  font-weight: ${p => p.theme.font.weight.normal};
  font-size: ${p => p.theme.font.size.caption};
  color: ${p => p.theme.color.red.primary};
  margin-left: 16px;
  text-align: left;
`

export const SelectSC = styled(Select)`
  appearance: none;
  background: url(/images/caret.svg) ${p => p.theme.color.background.primary} no-repeat right center;
  border: 1px solid ${p => p.theme.color.foreground.disabled};
  border-radius: 7px;
  color: ${p => p.theme.color.foreground.primary};
  font-size: ${p => p.theme.font.size.title};
  margin-top: 16px;
  outline: none;
  padding: 12px;
  width: 100%;
  & + & {
    margin-top: 24px;
  }
  &.errorField {
    border-color: ${p => p.theme.color.red.primary};
    background-image: url(/images/caret.svg), url(/images/error.svg);
    background-repeat: no-repeat, no-repeat;
    background-position:
      right center,
      right 40px top 50%;
    background-color: ${p => css`
        ${p.theme.color.background.primary}, ${p.theme.color.background.primary}
      `};
    background-size:
      26px 8px,
      23px 23px;
  }
`

export const SelectPlaceholder = styled.div`
  text-align: left;
  pointer-events: none;
  margin-top: -44px;
  color: ${p => p.theme.color.foreground.disabled};
  font-size: ${p => p.theme.font.size.title};
  padding: 10px 12px;
`

export const BtnSC = styled(Button)`
  &.orange {
    color: ${p => p.theme.color.background.primary};
    background-color: ${p => p.theme.color.orange.primary};
    border-color: ${p => p.theme.color.orange.primary};
    &[aria-disabled='true'] {
      background-color: ${p => p.theme.color.orange.tint25};
      border-color: ${p => p.theme.color.orange.tint25};
    }
  }

  &:focus {
    border: 1px solid ${p => p.theme.color.blue.primary};
  }

  & + & {
    margin-top: 16px;
  }
  ${mediaDesktop} {
    margin-top: 18px;
    &:only-child {
      margin-top: 0;
    }
  }
`

export const inputErr = css`
  border-color: ${p => p.theme.color.red.primary};
  background-image: url(/images/error.svg);
  background-color: ${p => p.theme.color.background.primary};
  background-repeat: no-repeat;
  background-size: 23px 23px;
  background-position: right 16px top 50%;
  &::placeholder {
    color: ${p => p.theme.color.red.primary};
  }
`

export const InputSC = styled(Input)`
  & + & {
    margin-top: 16px;
  }
  &.errorField {
    ${inputErr}
  }
  &.joined {
    font-size: ${p => p.theme.font.size.title};
    border: none;
    border-radius: 0;
    padding: 12px 0;
    & + & {
      margin-top: 0;
      border-top: 1px solid ${p => p.theme.color.foreground.disabled};
    }
    &.errorField {
      border-color: ${p => p.theme.color.red.primary};
      background-position: right 28px top 50%;
    }
  }
`

export const RadioLabel = styled(Label)`
  margin-bottom: 20px;
  color: ${p => p.theme.color.foreground.primary};
`
export const Radio = styled(Input)`
  width: 20px;
  height: 20px;
  vertical-align: text-bottom;
  margin: 0 14px 0 0;
  &:checked + span {
    font-weight: ${p => p.theme.font.weight.normal};
  }
`
